import { useContext } from 'react'
import { useSelector } from 'react-redux'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import * as publicationOptionActions from '@redux/modules/publicationOption'

import defaultState, { requiredFields } from '@models/publicationOption'

import PageContext from '@contexts/pageContext'

import type { PublicationOptionModel } from '@models/types'

// @ts-expect-error TS7006
const createPublicationOption = (params) => {
  const { publicationOptionParams, dispatch, requestOptions } = params
  const { createPublicationOption: createFn } = publicationOptionActions

  return dispatch(createFn(publicationOptionParams, requestOptions))
}

// @ts-expect-error TS7006
const deletePublicationOption = (params) => {
  const { publicationOption, dispatch } = params
  const { deletePublicationOption: deleteFn } = publicationOptionActions

  return dispatch(deleteFn(publicationOption))
}

// @ts-expect-error TS7006
const updatePublicationOption = (params) => {
  const { publicationOptionParams, dispatch, requestOptions } = params
  const { updatePublicationOption: updateFn } = publicationOptionActions

  return dispatch(updateFn(publicationOptionParams, requestOptions))
}

// @ts-expect-error TS7006
const createOrEditPublicationOption = params => new Promise((resolve, reject) => {
  const { publicationOption, showCreateOrEditPublicationOptionsModal } = params

  if (showCreateOrEditPublicationOptionsModal){
    const payload = {
      publicationOption,
    }

    showCreateOrEditPublicationOptionsModal(payload)

    resolve({ success: true, result: payload })
  }

  reject(new Error('showCreateOrEditPublicationOptionsModal not defined in PageContext callbacks'))
})

export function usePublicationOptionForm(publicationOption = {}, options = {}) {
  // @ts-expect-error TS2339
  const { validateOn } = options

  const publicationOptionForm = useForm(
    defaultState,
    { entity: publicationOption, requiredFields, validateOn },
    // @ts-expect-error TS2339
    [publicationOption.id, publicationOption.cache_key],
  )

  return {
    ...publicationOptionForm,
  }
}

export const useRelations = (publicationOption: Partial<PublicationOptionModel> = {}) => {
  const { publication_id } = publicationOption

  // @ts-expect-error TS18046
  const { publications } = useSelector(reduxState => reduxState.entities)

  const publication = publication_id && publications[publication_id]
    ? publications[publication_id] : {}

  return {
    publication,
  }
}

function usePublicationOption(initEntity: Partial<PublicationOptionModel> = {}) {
  // @ts-expect-error TS2345
  const { entity: publicationOption } = useLatestEntity(initEntity, 'publicationOptions')

  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditPublicationOptionsModal } = callbacks || {}

  // @ts-expect-error TS18046
  const { creating, deleting, updating } = useSelector(reduxState => reduxState.publicationOptions)

  return {
    callbacks: {
      createOrEditPublicationOption: () => (
        createOrEditPublicationOption({ publicationOption, showCreateOrEditPublicationOptionsModal })
      ),
      // @ts-expect-error TS7006
      createPublicationOption: (publicationOptionParams, requestOptions) => (
        createPublicationOption({ publicationOptionParams, dispatch, requestOptions })
      ),
      deletePublicationOption: () => deletePublicationOption({ publicationOption, dispatch }),
      // @ts-expect-error TS7006
      updatePublicationOption: (publicationOptionParams, requestOptions) => (
        updatePublicationOption({ publicationOptionParams, dispatch, requestOptions })
      ),
    },
    creating,
    deleting,
    publicationOption,
    updating,
  }
}

export default usePublicationOption
